import { SessionStorageKeys } from '@aglenergy/shared-library';
import { CustomerProfile } from 'app/shared/models/customerProfile';

class CustomerProfileService {
  public getCustomerProfile(): CustomerProfile {
    const customerProfile = sessionStorage.getItem(SessionStorageKeys.CustomerProfile)
      ? JSON.parse(sessionStorage.getItem(SessionStorageKeys.CustomerProfile)) || {}
      : {};
    return typeof customerProfile === 'object' && customerProfile !== null ? customerProfile : {};
  }

  public setCustomerProfile(customerProfile: CustomerProfile): void {
    if (typeof customerProfile === 'object' && customerProfile !== null) {
      window.sessionStorage.setItem(SessionStorageKeys.CustomerProfile, JSON.stringify(customerProfile));
    }
  }
}

export const customerProfileService = new CustomerProfileService();
